import React from 'react';
import { dateOptionStyle } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { Box, useTheme } from '@mui/material';

export const ShortVal: React.FC<{ value?: number; unit?: string }> = ({ value, unit }) => {
  const theme = useTheme();
  return (
    value &&
    unit && (
      <Box
        sx={{
          ...dateOptionStyle(theme),
          ...flex.center,
          gap: 1,
        }}>
        <span
          className="interval-shortval"
          style={{
            backgroundColor: 'var(--color-surface-interactive-modifier-default)',
            color: 'var(--color-content-base-secondary)',
            minWidth: '56px',
          }}>
          {value}
          {unit[0]}
        </span>
      </Box>
    )
  );
};
